import { fetcher } from "helpers/fetcher";

import { TGetEmployeeBasicInfoRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeBasicInfo = async (
  userId: string,
  language: string
) => {
  return await fetcher<TGetEmployeeBasicInfoRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_BASIC_INFO,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_BASIC_INFO.version,
        [API_HEADER.USER_ID]: userId,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetEmployeeBasicInfo = async (
  userId: string,
  language: string
) => {
  return (await getEmployeeBasicInfo(userId, language)).data;
};

queryGetEmployeeBasicInfo._key = (userId: string, language: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_BASIC_INFO.url,
  userId,
  language,
];
